import { createContext } from "react";

const LanguagePickerContext = createContext({
  set: (language: string) => {},
  value: "",
});

export default LanguagePickerContext;
